import css from 'styled-jsx/css'
import { colors } from '../../styles'

const {
  blackBg,
} = colors

export default css`
.Tabs {
  position: relative;
  padding: 0px 0px 16px 16px;
}

.Tabs :global(.tab-list) {
  justify-content: flex-start;
  height: 46px !important;
  padding: 0px;
}
.loader{
  display: -webkit-box;
  gap: 16px;
  flex-direction : row;
  overflow-y: hidden;
  overflow-x: auto;
  position: relative;
}
.scrollable-loader {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-right: 0px;
}
.sponsor{
  position: absolute;
    right: 8px;
    margin-top: -136%;
}
.Tabs.live{
padding-left: 0px;
}
.wrap{
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  justify-content: start;
  gap: 16px;
}

li {
  display: inline-block;
  padding-bottom : 40px;
  white-space: nowrap;
}

li + li {
  margin-left: 16px;
}

a, a:visited {
  display: inline-block;
  padding-bottom: 8px;
  transition: 150ms color;
  font-family: 'Source Sans Pro';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 30px;
display: flex;
align-items: center;

/* White 02 - #C4C4C4 */

color: #C4C4C4;
}

a:hover, a:focus {
  color: #F6F6F6;
}

/* stops focus ring appearing on click, but keeps it for keyboard nav */
a[tabindex="-1"]:focus {
  outline: none;
}
.active{
  border-bottom: 5px solid #F6F6F6;
}
.active a {
  font-weight: 600;
  color: #F6F6F6;
}

.tabs-content {
  /* make sure this covers the tab-list's scrollbars */
  min-height: 50px;
  padding-top: 26px;
  background: ${blackBg};
  position: relative;
}
.tabs-content.live {
  left: 0px;
}
@media(min-width: 499px){
    .sponsor{
      margin-top: -128%;
    }
}

@media(min-width: 768px) {
  .sponsor{
    position: relative;
    top: 0px;
    margin-top: 0px;
  }
  .tabs-content {
    padding-top: 16px;
  }
  a {
    font-size: 24px;
    padding-bottom: 8px;
  }

  .Tabs {
      position: relative;
      padding: 0px 0px 32px 24px;
  }
}
 @media(min-width: 1024px){
  .Tabs {
    padding-left: 48px;
  }
 }
 @media(min-width: 1200px){
  .Tabs {
    padding-left: 48px;
  }
 }
 @media(min-width: 2000px){
  .Tabs {
    padding-left: 64px;
  }
 }
`
